module.exports = __webpack_public_path__ + "media/bootstrap-icons/battery-full-010981ce.svg";